/**
 * Visualizador de imagem em modal (lightbox).
 *
 * Único lugar para "clicou na foto → amplia": chat, observações do pedido e
 * comprovantes. Antes cada tela fazia o seu: o chat forçava download com
 * `<a download>` e as observações abriam a URL assinada numa aba nova (que
 * mostrava o favicon antigo do site). Baixar continua possível pelo botão.
 */
import { Download, X } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export interface ImageLightboxProps {
  /** URL da imagem (assinada); null/undefined fecha o modal. */
  src: string | null | undefined;
  alt?: string;
  /** Nome sugerido ao baixar. */
  downloadName?: string;
  onClose: () => void;
}

export function ImageLightbox({ src, alt, downloadName, onClose }: ImageLightboxProps) {
  const baixar = () => {
    if (!src) return;
    const a = document.createElement('a');
    a.href = src;
    a.download = downloadName || 'imagem';
    a.target = '_blank';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Dialog open={!!src} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent
        className="max-w-[95vw] sm:max-w-[90vw] w-auto p-2 bg-black/95 border-none [&>button]:hidden"
        aria-describedby={undefined}
      >
        <DialogTitle className="sr-only">{alt || 'Imagem'}</DialogTitle>
        {src && (
          <img
            src={src}
            alt={alt || 'Imagem'}
            className="max-h-[85vh] max-w-full object-contain mx-auto rounded"
          />
        )}
        <div className="absolute top-2 right-2 flex gap-1">
          <Button size="icon" variant="secondary" onClick={baixar} aria-label="Baixar imagem">
            <Download className="h-4 w-4" />
          </Button>
          <Button size="icon" variant="secondary" onClick={onClose} aria-label="Fechar">
            <X className="h-4 w-4" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
